import { css, Theme } from '@emotion/react'

export const label = (theme: Theme) => css`
  font-weight: 400;
  color: ${theme.typographyColors.typographyThree};
  margin-bottom: 10px;
`

export const tabContent = (isVisible?: boolean) => css`
  display: ${isVisible ? 'flex' : 'none'};
  flex-direction: column;
  justify-content: space-between;
  gap: 24px;
`

export const columns = css`
  display: flex;
  gap: 24px;
`
